// This file centralizes the import of Leaflet and its markercluster plugin.
// The import order here is critical: leaflet MUST be imported before
// leaflet.markercluster, because the plugin extends the global L object.
// By isolating these imports in a single file, we prevent Prettier from
// reordering them in consumer files.
import L from "leaflet";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet/dist/leaflet.css";

export default L;
